import { Injectable, inject } from '@angular/core';
import { Platform } from '@ionic/angular';

const documentComputedStyle = getComputedStyle(document.documentElement);

export const hasSmallScreenLayout = (): boolean => {
  const maxWidth = parseInt(documentComputedStyle.getPropertyValue('--max-content-width-md'));

  return window.innerWidth < maxWidth;
};

@Injectable({
  providedIn: 'root',
})
export class PwaService {
  private platform = inject(Platform);

  public init(): void {
    console.info('init pwa service');
  }

  public isNative(): boolean {
    return this.platform.is('capacitor') || this.platform.is('cordova');
  }

  public isIos(): boolean {
    return this.platform.is('ios');
  }

  public isAndroid(): boolean {
    return this.platform.is('android');
  }

  public isWeb(): boolean {
    return this.isDesktop() || this.isMobileWeb();
  }

  public isDesktop(): boolean {
    return this.platform.is('desktop');
  }

  // true when touch device
  public isMobileWeb(): boolean {
    return this.platform.is('mobileweb');
  }
}
